import React from 'react';
import { GroupContext } from './GroupContext.js';

var Consumer = GroupContext.Consumer;

var GroupItem = function GroupItem(_ref) {
  var render = _ref.render;
  return /*#__PURE__*/React.createElement(Consumer, null, function (context) {
    return render(context);
  });
};

export default GroupItem;
//# sourceMappingURL=GroupItem.js.map
